angular.module('core').service('chatApi', ['cancelableResourceFactory', function ($cancelableResourceFactory) {
  var self = this;

  var ChatMessages = $cancelableResourceFactory.createCacheableResource('ChatMessages', '/api/v1/messaging/messages/list', {id: '@id'}, {
    list: {
      cache: false,
      url: '/api/v1/messaging/messages/list',
      method: 'POST',
      isArray: false
    },
    count: {
      cache: false,
      url: '/api/v1/messaging/messages/count',
      method: 'POST',
      isArray: false
    },
    new: {
      cache: false,
      url: '/api/v1/messaging/messages/new',
      method: 'POST',
      isArray: false
    },
    update: {
      cache: false,
      url: '/api/v1/messaging/messages/update',
      method: 'POST',
      isArray: false
    },
    snapshot: {
      cache: false,
      url: '/api/v1/messaging/users/:studentId/files/:imageId',
      method: 'GET',
      isArray: true,
      transformResponse: function(body) {
        return [body]; // needed as observables use array-like objects, otherwise its converted automatically to array of chars
      }
    }
  });


  /**************************************************************/
  /*                          Api                               */
  /**************************************************************/

  self.getMessages = function(studentIds) {
    return ChatMessages.list({studentIds: studentIds}).$promise;
  };

  self.getMessagesCount = function(studentIds) {
    return ChatMessages.count({studentIds: studentIds}).$promise;
  };

  self.sendMessage = function(studentIds, classroomId, message, stock) {
    return ChatMessages.new({studentIds: studentIds, classroomId: classroomId, messageText: message, stockId: stock}).$promise;
  };

  self.updateMessage = function(studentId, updates) {
    return ChatMessages.update({studentId: studentId, updates: updates}).$promise;
  };

  self.getSnapshot = function(studentId, imageId) {
    return ChatMessages.snapshot({studentId: studentId, imageId: imageId}).$promise;
  };
}]);
